// extracted by mini-css-extract-plugin
module.exports = {"container":"LoaderColumn_container__nyKaL","type-Column":"LoaderColumn_type-Column__2mP3g","type-Row":"LoaderColumn_type-Row__3SYBo"};